import { LogRequestStatus } from '../api/types';

/** Maps a request status to a CSS modifier class. */
const STATUS_CLASS: Record<LogRequestStatus, string> = {
  PENDING: 'badge badge--pending',
  COMPLETED: 'badge badge--completed',
  EXPIRED: 'badge badge--expired',
  FAILED: 'badge badge--failed',
};

/**
 * Coloured pill rendering a {@link LogRequestStatus}.
 *
 * @param props.status - The request status to display.
 */
export function StatusBadge({ status }: { status: LogRequestStatus }) {
  return <span className={STATUS_CLASS[status]}>{status}</span>;
}
